import type { ReactNode } from 'react';

interface WarnBoxProps {
  children: ReactNode;
  variant?: 'red' | 'amber';
  /** True to render as the final, larger warning box (white bg, more padding). */
  final?: boolean;
}

/**
 * The red (or amber) warning banner used inside cards or as a standalone full-width banner.
 * Hard ink shadow in the same color as the border (matches the Dessinée look).
 */
export function WarnBox({ children, variant = 'red', final = false }: WarnBoxProps) {
  const palette =
    variant === 'amber'
      ? { border: '#c69c1d', text: '#a07c10', bg: '#fdf5d8' }
      : { border: '#d34a4a', text: '#d34a4a', bg: '#fdecec' };

  if (final) {
    return (
      <div
        className="mt-3 border-[2.5px] rounded-card bg-white px-[14px] py-[10px] font-hand text-[15.5px] flex gap-[10px] items-start"
        style={{
          borderColor: palette.border,
          color: palette.text,
          boxShadow: `3px 4px 0 ${palette.border}`,
        }}
      >
        {children}
      </div>
    );
  }

  return (
    <div
      className="mt-[10px] border-[2.5px] rounded-[12px] px-[14px] py-[6px] pt-[8px] font-hand text-[15.5px] flex items-center gap-2"
      style={{
        borderColor: palette.border,
        color: palette.text,
        background: palette.bg,
        boxShadow: `3px 3px 0 ${palette.border}`,
      }}
    >
      {children}
    </div>
  );
}
